import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { State } from 'redux/initialState';

import isSuperAdmin from 'utils/isSuperAdmin';
import { useTranslate } from 'hooks/useTranslate';
import { hasShowDetails } from 'utils/showDetails';

import toggleSideNav from 'modules/_shared/redux/sideNavActions';
import { MenuOption } from 'modules/_shared/types/MenuOption';

import menuOptions from './menuOptions';
import WizardButton from '../Buttons/WizardButton';
import UserMenuDots from '../MenuDots/UserMenuDots';
import AiAgentButton from '../Buttons/AiAgentButton';
import ToggleWidthButton from '../Buttons/ToggleWidthButton';
import NotificationButton from '../NotificationButton';

type HeaderToolsProps = {
  data: Record<string, any>;
};

const isUILimitedVersion = !!JSON.parse(
  process.env.REACT_APP_UI_LIMITED_VERSION || 'false'
);

const HeaderTools = ({ data }: HeaderToolsProps) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  return (
    <div className="nk-header-tools">
      <ul className="nk-quick-nav">
        {data?.hasSocietyButtonEnabled && !isUILimitedVersion && (
          <Link
            to="/nueva-sociedad"
            className="btn btn-outline-primary d-none d-md-inline-flex no-wrap"
          >
            {t('AddSociety')}
          </Link>
        )}

        {isSuperAdmin(data?.user) &&
          data?.hasSocietyButtonEnabled &&
          !isUILimitedVersion && (
            <li className="d-none d-md-inline">
              <WizardButton />
            </li>
          )}

        {hasShowDetails() && (
          <li className="d-none d-md-inline">
            <AiAgentButton disabled={!actualSociety} society={actualSociety} />
          </li>
        )}

        <li className="d-none d-md-inline pl-0">
          <ToggleWidthButton />
        </li>

        {hasShowDetails() && (
          <li className="d-none d-md-inline ml-2">
            <NotificationButton />
          </li>
        )}

        <li className="dropdown user-dropdown">
          <UserMenuDots menuOptions={menuOptions as MenuOption[]} />
        </li>

        <li className="d-lg-none">
          {data?.showSideNav}
          <a
            className="toggle nk-quick-nav-icon mr-n1"
            data-target="sideNav"
            aria-label="temp"
            onClick={() => dispatch(toggleSideNav())}
          >
            <em className="icon ni ni-menu" />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default HeaderTools;
